var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import styles from './file.styles';
import { classMap } from 'lit/directives/class-map.js';
import { dictionary } from '@mf-cms/helpers';
import { MFElement } from '../mfelement/mfelement';
let PFile = class PFile extends MFElement {
    constructor() {
        super(...arguments);
        this.inactive = false;
        this.selectable = false;
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
     * Handle click event on the file element
     * @returns {void}
     */
    fileClick() {
        const filePreview = document.querySelector('p-file-preview');
        if (filePreview) {
            const allFiles = this.parentNode?.querySelectorAll('p-file');
            const allFilesIds = Array.from(allFiles).map((file) => file.fileId);
            filePreview.open(this.fileId, allFilesIds);
        }
        this.dispatchEvent(new CustomEvent('p-file-click', { bubbles: true, composed: true }));
    }
    /**
     * Handle keydown event on the file element
     * @param {KeyboardEvent} e - Keyboard event
     * @returns {void}
     */
    fileKeydown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.fileClick();
        }
    }
    /**
     * Set focus on the file element
     * @returns {void}
     */
    setFocus() {
        this.fileElm?.focus();
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const classes = {
            icon: this.icon,
            transparent: this.transparent,
            selected: this.selected,
            video: this.video,
            selectable: this.selectable,
            inactive: this.inactive,
            [`layout-${this.layout}`]: true
        };
        if (this.loading) {
            return html ` <p-skeleton ratio="1/1"></p-skeleton> <p-skeleton height="20px" width="70%"></p-skeleton> `;
        }
        if (this.layout == 'masonry') {
            let ratio = '';
            if (!this.icon && this.height && this.width) {
                ratio = 'aspect-ratio:' + this.width + '/' + this.height;
            }
            return html ` <div class="file file-masonry ${classMap(classes)}" role="button" tabindex="0" style=${ratio} aria-label="${dictionary(this.culture, 'file', 'file')}: ${this.name}" @click=${this.fileClick} @keydown=${this.fileKeydown} > <div class="preview"> ${this.imageMedium ? html ` <img draggable="false" src=${this.imageMedium} alt=${this.name} /> `
                : ''}
            ${this.video
                ? html ` <div class="video-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16" > <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" /> <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" /> </svg> </div> `
                : ''}
          </div>
          <div class="file-masonry-info">
            <div class="name" title=${this.name}>${this.name}</div>
            <div class="file-masonry-info-meta">
              ${this.type && this.showType
                ? html `<div class="file-masonry-meta-item type" aria-label="${dictionary(this.culture, 'file', 'type')}: ${this.type}" > ${this.type} </div>`
                : ''}
              ${this.dimensions && this.showDimensions
                ? html `<div class="file-masonry-meta-item" aria-label="${dictionary(this.culture, 'file', 'dimensions')}: ${this.dimensions}" > ${this.dimensions} </div>`
                : ''}
              ${this.size && this.showSize
                ? html `<div class="file-masonry-meta-item" aria-label="${dictionary(this.culture, 'file', 'size')}: ${this.size}" > ${this.size} </div>`
                : ''}
            </div>
          </div>
        </div>
      `;
        }
        else if (this.layout == 'list') {
            return html ` <div class="file file-list ${classMap(classes)}" role="button" tabindex="0" aria-label="${dictionary(this.culture, 'file', 'file')}: ${this.name}" @click=${this.fileClick} @keydown=${this.fileKeydown} > <div class="list-col list-image"> <div class="preview"> ${this.imageSmall ? html ` <img draggable="false" src=${this.imageSmall} alt=${this.name} /> `
                : ''}
              ${this.video
                ? html ` <div class="video-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16" > <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" /> <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" /> </svg> </div> `
                : ''}
            </div>
          </div>
          <div class="list-col list-name">
            <div class="name" title=${this.name}>${this.name}</div>
          </div>
          ${this.showDimensions
                ? html ` <div class="list-col list-dimensions"> ${this.dimensions ? html `<div
                        aria-label="${dictionary(this.culture, 'file', 'dimensions')}: ${this
                    .dimensions}"
                      >
                        ${this.dimensions}
                      </div>`
                    : ''}
                </div>
              `
                : ''}
          ${this.showType
                ? html ` <div class="list-col list-type"> ${this.type ? html `<div
                        class="type"
                        aria-label="${dictionary(this.culture, 'file', 'type')}: ${this.type}"
                      >
                        ${this.type}
                      </div>`
                    : ''}
                </div>
              `
                : ''}
          ${this.showSize
                ? html ` <div class="list-col list-size"> ${this.size ? html `<div
                        aria-label="${dictionary(this.culture, 'file', 'size')}: ${this.size}"
                      >
                        ${this.size}
                      </div>`
                    : ''}
                </div>
              `
                : ''}
        </div>
      `;
        }
        else {
            return html ` <div class="file ${classMap(classes)}" role="button" tabindex="0" aria-label="${dictionary(this.culture, 'file', 'file')}: ${this.name}" @click=${this.fileClick} @keydown=${this.fileKeydown} > <div class="preview"> ${this.imageSmall ? html `
                  <img
                    draggable="false"
                    src=${this.layout == 'grid' ? this.imageMedium : this.imageSmall}
                    alt=${this.name}
                  />
                `
                : ''}
            ${this.video
                ? html ` <div class="video-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16" > <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" /> <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" /> </svg> </div> `
                : ''}
          </div>
          <div class="info">
            <div class="info-top">
              <div class="name" title=${this.name}>${this.name}</div>
              ${this.selectable
                ? html ` <p-checkbox label="Select file ${this.name}" label-hidden ?checked=${this.selected} input-id="select-file-${this.fileId}" > </p-checkbox> `
                : ''}
            </div>
            <div class="info-meta">
              ${this.dimensions && this.showDimensions
                ? html `<div aria-label="${dictionary(this.culture, 'file', 'dimensions')}: ${this.dimensions}" > ${this.dimensions} </div>`
                : ''}
            </div>
            <div class="info-bottom">
              ${this.type && this.showType
                ? html `<div class="type" aria-label="${dictionary(this.culture, 'file', 'type')}: ${this.type}" > ${this.type} </div>`
                : ''}
              ${this.size && this.showSize
                ? html `<div class="size" aria-label="${dictionary(this.culture, 'file', 'size')}: ${this.size}" > ${this.size} </div>`
                : ''}
            </div>
          </div>
        </div>
      `;
        }
    }
};
__decorate([
    property({ type: String, attribute: 'file-id' })
], PFile.prototype, "fileId", void 0);
__decorate([
    property({ type: String, attribute: 'image-thumb' })
], PFile.prototype, "imageThumb", void 0);
__decorate([
    property({ type: String, attribute: 'image-small' })
], PFile.prototype, "imageSmall", void 0);
__decorate([
    property({ type: String, attribute: 'image-medium' })
], PFile.prototype, "imageMedium", void 0);
__decorate([
    property({ type: String, attribute: 'image-large' })
], PFile.prototype, "imageLarge", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "name", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "alt", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "type", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "width", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "height", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "dimensions", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PFile.prototype, "selected", void 0);
__decorate([
    property({ type: Boolean })
], PFile.prototype, "transparent", void 0);
__decorate([
    property({ type: Boolean })
], PFile.prototype, "video", void 0);
__decorate([
    property({ type: Boolean })
], PFile.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], PFile.prototype, "used", void 0);
__decorate([
    property({ type: String, reflect: true })
], PFile.prototype, "layout", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PFile.prototype, "inactive", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PFile.prototype, "selectable", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-size' })
], PFile.prototype, "showSize", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-type' })
], PFile.prototype, "showType", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-dimensions' })
], PFile.prototype, "showDimensions", void 0);
__decorate([
    property({ type: String })
], PFile.prototype, "culture", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'loading' })
], PFile.prototype, "loading", void 0);
__decorate([
    query('.file')
], PFile.prototype, "fileElm", void 0);
PFile = __decorate([
    customElement('p-file')
    /**
     * PFile component
     *
     * @class PFile
     * @typedef {PFile}
     * @extends {LitElement}
     */
], PFile);
export { PFile };
